import { Component } from '@angular/core';

@Component({
  selector: 'eiq-grid-filter-skeleton',
  templateUrl: 'grid-filter-skeleton.component.html',
  styleUrls: ['grid-filter-skeleton.component.scss']
})
export class GridFilterSkeletonComponent {}
